import classNames from "classnames";
import { forwardRef, type MutableRefObject } from "react";
import EdgeCropView from "./edgeCrop";
import styles from "./index.module.less";
import { IRectCoordinate, useEdgeCrop } from "./useEdgeCrop";

interface IProps {
  onResizeEnd?: (co: IRectCoordinate) => void;
  className?: string;
  children: React.ReactNode;
  defaultCoordinate?: IRectCoordinate;
}

function RawEdgeCrop(
  { className, children, onResizeEnd, defaultCoordinate }: IProps,
  ref: MutableRefObject<{
    setCoordinate: (co: IRectCoordinate) => void;
  }>
) {
  const { coordinate, resizeCoordinate, targetRef, setCoordinate } =
    useEdgeCrop({
      onResizeEnd,
      defaultCoordinate,
    });

  ref.current = { setCoordinate };

  return (
    <div className={classNames(styles.crop, className)} ref={targetRef}>
      {children}
      <EdgeCropView
        coordinate={coordinate}
        resizeCoordinate={resizeCoordinate}
      />
    </div>
  );
}

const EdgeCrop = forwardRef(RawEdgeCrop);
export default EdgeCrop;
